<template>
    <div>
        <div class="display-inline" v-on:click="noticeModal($event)">
            <slot name="modal-link"></slot>
        </div>
        <modal :show.sync="modals.classic" headerClasses="justify-content-center" @close="onClose">
            <h4 slot="header" class="title title-up">Upload Documents</h4>
            <hr />
            <div class="container">
                <!-- Browse Button -->
                <div class="row">
                    <div class="col-md-7">
                        <label>Please select a document to upload:<br>
                            <small class="red">*PDF/PNG/JPG/JPEG Document files with a size less than 10MB</small>
                        </label>
                    </div>
                    <div class="col-md-5 d-flex justify-content-end more-top-padding more-bottom-padding no-right-padding">
                        <base-button type="file">
                            <span><i class="tim-icons icon-laptop"></i> Browse</span>
                            <input
                                v-validate="'required'" 
                                :error="getError('file')" 
                                name="file" 
                                type="file" 
                                 accept=".pdf,.png,.jpg,.jpeg"
                                @change="setUploadedFile" 
                                />
                        </base-button>                      
                    </div>
                     <span v-show="errors.has('file')" class="error">
                          A file is required
                        </span>
                </div>
                <!-- Selected File -->
                <div v-if="document.file" class="row">
                    <div class="col-md-3">
                        <label>Selected File</label>
                    </div>
                    <base-input
                        v-model="document.file.name" 
                        class="col-md-9" 
                        type="text" 
                        name="ufile"
                        placeholder="No file selected" 
                        addon-left-icon="tim-icons icon-attach-87"
                    ></base-input>

                </div>
    
                <base-input>
                    <label>Type</label>
                    <v-select 
                        v-model="document.type" 
                        name="type" 
                        label="name" 
                        :reduce="type => type.id" 
                        :options="userFileTypes" 
                        v-validate="'required'"
                        placeholder="Select one"></v-select>
                </base-input>
                <span v-show="errors.has('type')" class="error">
                    Please select a file type
                </span>
                <!-- <base-input>
                    <label>Remark</label>
                    <textarea class="form-control" placeholder="(Optional) Add notes about this document..." rows="3" v-model="document.remark"></textarea>
                </base-input> -->
            </div>
            <template slot="footer">
                <div class="container alert_footer">
                    <base-button type="danger" @click.native="modals.classic = false" class="mr-4">
                        <span><i class="tim-icons icon-simple-remove"></i> Cancel</span>
                    </base-button>
                    <base-button :disabled="!document.file" type="primary" @click.native="submit">
                        <span><i class="tim-icons icon-cloud-upload-94"></i> {{ savingDocument ? "Saving..." : "Add" }}</span>
                    </base-button>
                </div>
            </template>
        </modal>
    
    </div>
    </template>
    
    <script>
    import {
        BaseButton,
        Modal
    } from '@/components'
    import {
        Upload
    } from 'element-ui'
    import Swal from 'sweetalert2'; // new import for Swal latest version
    
    
    export default {
        name: "UserDocumentsModal",
        props: {
            email: {
                type: String,
                default: null
            },
            isIcon: {
                type: Boolean,
                default: false
            },
            isNew: {
                type: Boolean,
                default: false
            },
            isTransactionCompletion: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                tempIds: [],
                modals: {
                    classic: false,
                },
                userFileTypes: [],
                savingDocument: false,
                test: null,
                document: {
                    id: 0,
                    file: null,
                    type: null,
                    remark: ""
                },
                options: [],
                renderKey: 0,
            };
        },
        components: {
            BaseButton,
            Modal,
            Upload
        },
        computed: {
            fileRule() {
                return this.isNew ? 'required' : ''
            }
        },
        methods: {
            noticeModal: function (event) {
                this.openModal()
            },
            openModal() {
                let ctx = this;
                ctx.getUserFileTypes().then(() => {
                    ctx.modals.classic = true
                })
            },
            async getUserFileTypes() {
                if(!this.isTransactionCompletion){
                const response = await this.axios.get("/api/applicationuserfiletypes");
                const other = response.data.find((element) => element.name === 'OTHER');
                const filteredData = response.data.filter(function(element) {
                    return element.name != 'OTHER'
                    })
                    filteredData.sort(function(a, b) {
                    if (!a || !b) return 0;
                    var textA = (a.name || "").toUpperCase();
                    var textB = (b.name || "").toUpperCase();
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                        });
                        filteredData.push(other)
                        this.userFileTypes = filteredData
                    }else {
                        this.userFileTypes = [{id: 5 , name: "TRANSACTION COMPLETION"}]
                    }
            },
            setUploadedFile(e) {
                const files = e.target.files;

                // Check if any file is selected
                if (!files || files.length === 0) {
                    this.document.file = null;
                    // e.target.value = null; 
                    return;
                }

                const selectedFile = files[0];
                const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
                const maxFileSize = 10 * 1024 * 1024; // 10MB in bytes

                // Check file type
                if (!allowedTypes.includes(selectedFile.type)) {
                    this.$toast.error("Invalid File Format. Please upload PDF, PNG, JPG, or JPEG files.");
                    this.document.file = null;
                    e.target.value = null; // Reset the actual file input field
                    return;
                }

                // Check file size!
                if (selectedFile.size > maxFileSize) {
                    this.$toast.error("File is too large. Please upload files smaller than 10MB.");
                    this.document.file = null; 
                    e.target.value = null; 
                    return;
                }

                this.document.file = selectedFile;
            },
             showLoadingSweetAlert(message) {
                new Swal({
                    position: "top-end",
                    icon: "warning",
                    title: "Please Wait Patiently",
                    html: message,
                    timer: 10000,
                    showConfirmButton: false,
                });
            },
            async submit(e) {
                if (this.savingDocument) return;
                this.savingDocument = true;
                this.$validator.validateAll().then(isValid => {
                    if (isValid) {
                        /**CRUCIAL VALIDATION**/
                        if (!this.document.file) {
                          this.$toast.error("Please select a valid file.");
                          this.savingDocument = false;
                          return;
                        }
                        if (!this.document.type) { // Check if type is selected
                          this.$toast.error("Please select a file type.");
                          this.savingDocument = false;
                          return;
                        }
                        /**END VALIDATION**/
                        this.saveFile(); // Proceed to save/emit
                        // Note: savingDocument is not reset here because the parent component handles the logic
                        // and usually closes the modal. If we reset it immediately, double-click is possible.
                        // However, if the parent fails, we might be stuck. 
                        // But since this component just emits and doesn't wait for a promise, 
                        // we rely on the modal closing.
                        setTimeout(() => { this.savingDocument = false; }, 2000); // Safety timeout
                    } else {
                        this.savingDocument = false;
                        let error = this.errors.items.length > 1
                            ? "Please fill in all required fields." 
                            : this.errors.items[0].msg  ;
                        this.$toast.error(error);
                    }
                });
            },
            saveFile() {
                // Find the full fileType object using the ID stored in this.document.type
                const fullFileTypeObject = (this.document.type && typeof this.document.type === 'object') 
                                       ? this.document.type 
                                       : this.userFileTypes.find(t => t.id === this.document.type);

                if (!fullFileTypeObject) {
                    // Ideally, this should not happen if validation passes and userFileTypes is populated
                    this.$toast.error("Selected file type is invalid. Please re-select.");
                    return; 
                }

                // New object to emit with the full type object
                const documentToEmit = {
                    file: this.document.file,
                    type: fullFileTypeObject,
                    remarks: this.document.remarks
                };
                this.$emit("reloadDocuments", documentToEmit);
            },
            clearDocument(openModal) {
                this.modals.classic = openModal;      
                this.document.file = null;
                this.document.type = null;
                this.document.remarks = '';
                this.document.id = 0;
            },
            getError(fieldName) {
                return this.errors.first(fieldName);
            },
            onClose() {
                this.$emit('modal-closed');
            }
        }
    }
    </script>
